module.exports = __webpack_public_path__ + "img/doubt.66f011bc.png";